import React from 'react';
import LegalDocumentPage from '../components/LegalDocumentPage';
import { privacySections } from '../config/compliance';

export default function PrivacyPolicy() {
  return (
    <LegalDocumentPage
      title="隐私政策"
      sections={privacySections}
      relatedLinks={[{ to: '/agreement', label: '用户协议' }]}
    />
  );
}
